import * as React from 'react';
import TransactionHistory from '../../components/transaction/TransactionHistory';
import { useNavigate } from 'react-router-dom';
import Storage from '../../services/Storage';

export default function Transaction() {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (Storage.getLocalAccessToken() === null) {
      navigate('/signin', { replace: true })
    }
  }, [navigate])
  return (
    <TransactionHistory></TransactionHistory>
  );
}